import styled from "styled-components";
import { CreateButton } from "../Header/Header.styled";

export const CreateNftWrapper = styled.div`
  margin: 50px 0;
`;

export const CreateNftWrapperMain = styled.div`
  display: flex;
  @media (max-width: 991.98px) {
    flex-direction: column;
  }
`;

export const CreateNftLeft = styled.div`
  width: 50%;
  padding-right: 40px;
  @media (max-width: 991.98px) {
    width: 100%;
    padding-right: 0;
  }
  & label {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: ${(props) => props.theme.bgColor};
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 10px;
    width: 100%;
    height: 635px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-family: "Inter";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 145.7%;
    text-align: center;
    color: ${(props) => props.theme.subtitleColor};
    @media (max-width: 767.98px) {
      height: 400px;
    }
  }
  & input {
    display: none;
  }
  & button {
    background: ${(props) => props.theme.buttonBg};
    border-radius: 25px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #0088cc;
    border: 1px solid #0088cc;
    width: 130px;
    height: 32px;
    cursor: pointer;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg {
      margin-right: 10px;
    }
  }
`;

export const CreateNftRight = styled.div`
  width: 50%;
  padding-left: 40px;
  @media (max-width: 991.98px) {
    width: 100%;
    padding-left: 0;
    margin-top: 40px;
  }
`;

export const CreateNftButton = styled(CreateButton)`
  width: 100%;
  margin: 30px 0 25px;
  height: 50px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 126.2%;
`;

export const CreateNftContent = styled.div`
  background: ${(props) => props.theme.body};
  box-shadow: 1px 6px 20px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  padding: 25px;
  & h3 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
  }
`;

export const CreateNftSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 25px 0;
  & h5 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767.98px) {
      font-size: 16px;
    }
    & span {
      font-family: "Inter";
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 145.7%;
      color: ${(props) => props.theme.subtitleColor};
    }
  }
  & h6 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 145.7%;
    color: ${(props) => props.theme.subtitleColor};
    @media (max-width: 767.98px) {
      font-size: 14px;
    }
    & span {
      font-weight: bold;
    }
  }
  & label {
    position: relative;
    & span {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 18px;
      color: ${(props) => props.theme.textColor};
    }
  }
  & input {
    width: 100%;
    background: ${(props) => props.theme.body};
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 5px;
    padding: 10px;
    color: ${(props) => props.theme.textColor};
    outline: none;
  }
  & textarea {
    width: 100%;
    background: ${(props) => props.theme.body};
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 5px;
    padding: 10px;
    outline: none;
  }
  & .switch {
    > div {
      border: 1px solid ${(props) => props.theme.textColor};
    }
  }
`;

export const CreateNftInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f2f3ff;
  border-radius: 5px;
  width: 100%;
  background: ${(props) => props.theme.hover};
  border-radius: 5px;
  padding: 10px;
  color: ${(props) => props.theme.textColor};
  margin-top: 15px;
  height: 46px;
  & div {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    color: ${(props) => props.theme.textColor};
    @media (max-width: 767.98px) {
      font-size: 12px;
      line-height: 12px;
    }
  }
  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    margin: 0 15px;
    color: ${(props) => props.theme.subtitleColor};
    @media (max-width: 767.98px) {
      font-size: 12px;
      line-height: 12px;
    }
  }
`;
